import { Grid, LoadingOverlay, Paper, Stack } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import InputField, { InputFieldTypes } from "../components/input_field";
import { CallsChart } from "../components/reports/call_chats";
import { useAuth } from "../contexts/auth.context";
import { GET_STATS, GET_WL_STATS } from "../services/companies";
import Metrics from "../components/reports/metrics";

export default function Home() {
	const { userData, roles } = useAuth();

	const [valuesPerFilter, setValuesPerFilter] = useState<any>({});
	const [loadingPerFilter, setLoadingPerFilter] = useState<any>({});
	// const [wLValuesPerFilter, setWLValuesPerFilter] = useState<any>({});
	// const [loadingWlPerFilter, setLoadingWlPerFilter] = useState<any>({});

	const [options, setOptions] = useState<any>();

	const [wlCompany, setWlCompany] = useState<string>(userData?.whitelabel?.company?.id);
	const [company, setCompany] = useState<string>(userData?.company?.id);
	const [period, setPeriod] = useState<[Date, Date]>([
		moment().startOf("month").toDate(),
		moment().endOf("month").toDate(),
	]);

	const companiesChildren = useMemo(() => (
		userData?.user?.whitelabelAdmin
			? ((options?.companies ?? []).find((c: any) => c.id === wlCompany)?.children ?? [])
			: (roles ?? []).map((r: any) => ({ name: r?.company?.name, id: r?.company?.id }))
	), [options, wlCompany, userData]);

	const activesChildren = useMemo(() => (
		companiesChildren.filter((c: any) => c.active)
	), [companiesChildren]);

	const wlFilters = useMemo(() => ({
		dateStart: moment(period[0]).format(),
		dateEnd: moment(period[1]).format(),
		company: wlCompany,
	}), [wlCompany, period]);

	const filters = useMemo(() => ({
		dateStart: moment(period[0]).format(),
		dateEnd: moment(period[1]).format(),
		company,
	}), [company, period]);

	const values = useMemo(() => valuesPerFilter[`${JSON.stringify(filters)}`], [filters, valuesPerFilter]);
	// const wlValues = useMemo(() => wLValuesPerFilter[`${JSON.stringify(wlFilters)}`], [wlFilters, wLValuesPerFilter]);
	const loading = useMemo(() => (
		loadingPerFilter[`${JSON.stringify(filters)}`]
		// loadingWlPerFilter[`${JSON.stringify(wlFilters)}`]
	), [filters, loadingPerFilter, wlFilters]);

	useEffect(() => {
		if (moment(filters.dateStart).isValid() && moment(filters.dateEnd).isValid()) {
			const key = `${JSON.stringify(filters)}`;
			setLoadingPerFilter((v: any) => ({ ...v, [key]: true }));
			GET_STATS(filters)
				.then(({ values, options }) => {
					setValuesPerFilter((v: any) => ({ ...v, [key]: values }));
					setOptions(options);
				})
				.catch(err => {
					showNotification(err.message);
				}).finally(() => {
					setLoadingPerFilter((v: any) => ({ ...v, [key]: false }));
				})
		}
	}, [filters]);

	// useEffect(() => {
	// 	if (userData?.user?.whitelabelAdmin) {
	// 		const key = `${JSON.stringify(wlFilters)}`;
	// 		setLoadingWlPerFilter((v: any) => ({ ...v, [key]: true }));
	// 		GET_WL_STATS(wlFilters)
	// 			.then((res: any) => {
	// 				setWLValuesPerFilter((v: any) => ({ ...v, [key]: res }));
	// 				setOptions(options);
	// 			})
	// 			.catch(err => {
	// 				showNotification(err.message);
	// 			}).finally(() => {
	// 				setLoadingWlPerFilter((v: any) => ({ ...v, [key]: false }));
	// 			})
	// 	}
	// }, [userData?.user?.whitelabelAdmin, wlFilters]);

	useEffect(() => {
		if (wlCompany) {
			let ccs = ((options?.companies ?? []).find((c: any) => c.id === wlCompany)?.children ?? []).sort((a: any, b: any) => a.created_at > b.created_at ? 1 : -1);
			setCompany(c => (!c || (!!options && !ccs.some((c2: any) => c2.id === c))) ? ccs[0]?.id : c);
		}
	}, [userData, wlCompany, options]);

	return <Stack>
		<LoadingOverlay visible={loading} />
		{userData?.user?.whitelabelAdmin && <>
			<Paper p="md">
				<Grid>
					<Grid.Col span={{ md: 3 }}>
						<InputField
							fieldType={InputFieldTypes.SELECT}
							value={wlCompany}
							clearable={false}
							options={(options?.companies ?? []).map((c: any) => ({ label: c.name, value: c.id }))}
							onChange={({ c }) => setWlCompany(c)}
							name="c"
						/>
					</Grid.Col>
					<Grid.Col span={{ md: 4 }}>
						<InputField
							fieldType={InputFieldTypes.DATERANGE}
							value={period}
							clearable={false}
							onChange={({ p }) => setPeriod(p)}
							name="p"
						/>
					</Grid.Col>
				</Grid>
			</Paper>
		</>
		}

		<Paper p="md">
			<Grid>
				<Grid.Col span={{ md: 3 }}>
					<InputField
						fieldType={InputFieldTypes.SELECT}
						value={company}
						clearable={false}
						options={companiesChildren.map((c: any) => ({ label: c.name, value: c.id }))}
						onChange={({ c }) => setCompany(c)}
						name="c"
					/>
				</Grid.Col>
				<Grid.Col span={{ md: 4 }}>
					{!userData?.user?.whitelabelAdmin && <InputField
						fieldType={InputFieldTypes.DATERANGE}
						value={period}
						clearable={false}
						onChange={({ p }) => setPeriod(p)}
						name="p"
					/>}
				</Grid.Col>
			</Grid>
		</Paper>

		<Metrics
			values={values?.metrics}
			workspaces={{
				actives: activesChildren.length,
				total: companiesChildren.length,
			}}
		/>

		<CallsChart
			callVolume={values?.callVolume}
			status={values?.status}
			campaigns={values?.campaigns}
		/>
	</Stack>
}
